/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscountAgreement
 */
export interface DiscountAgreement {
    /**
     * 
     * @type {DiscountAgreementTypeEnum}
     * @memberof DiscountAgreement
     */
    type: DiscountAgreementTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscountAgreement
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DiscountAgreement
     */
    regularDiscount: number;
    /**
     * 
     * @type {Date}
     * @memberof DiscountAgreement
     */
    createdAt: Date;
}


/**
 * @export
 */
export const DiscountAgreementTypeEnum = {
    Producer: 'PRODUCER',
    Custom: 'CUSTOM',
    Theme: 'THEME',
    Producttype: 'PRODUCTTYPE'
} as const;
export type DiscountAgreementTypeEnum = typeof DiscountAgreementTypeEnum[keyof typeof DiscountAgreementTypeEnum];


/**
 * Check if a given object implements the DiscountAgreement interface.
 */
export function instanceOfDiscountAgreement(value: object): value is DiscountAgreement {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('regularDiscount' in value) || value['regularDiscount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function DiscountAgreementFromJSON(json: any): DiscountAgreement {
    return DiscountAgreementFromJSONTyped(json, false);
}

export function DiscountAgreementFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountAgreement {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'],
        'regularDiscount': json['regularDiscount'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function DiscountAgreementToJSON(json: any): DiscountAgreement {
    return DiscountAgreementToJSONTyped(json, false);
}

export function DiscountAgreementToJSONTyped(value?: DiscountAgreement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
        'regularDiscount': value['regularDiscount'],
        'createdAt': value['createdAt'].toISOString(),
    };
}

